export default "__VITE_ASSET__68BnGKiK__"